<div *ngIf="showPropertyInfo()">
  <p class="title">PROPERTY INFO:</p>
  <ul *ngFor="let feature of triageFeatures">
    <li>Id: <strong>{{ feature.id }}</strong></li>
    <li>Shape: <strong>{{ feature.shape ? (feature.shape | titlecase) : 'Unavailable' }}</strong></li>
    <li>Material: <strong>{{ feature.material ? (feature.material | titlecase) : 'Unavailable' }}</strong></li>
  </ul>
</div>

<mat-divider *ngIf="showPropertyInfo() && showWeatherInfo()"></mat-divider>

<div *ngIf="showWeatherInfo()">
  <p class="title">WEATHER INFO:</p>
  <ul>
    <ng-container *ngFor="let feature of weatherFeatures">
      <li *ngIf="feature.units === 'LENGTH_SMALL'">{{ feature.text }}: <strong>{{ feature.value | length : getUnitsConversion(feature.units) : 2 : true }}</strong></li>
      <li *ngIf="feature.units === 'SPEED'">{{ feature.text }}: <strong>{{ feature.value | speed : getUnitsConversion(feature.units) : 0 : true }}</strong></li>
      <li *ngIf="feature.units === 'PROBABILITY'">{{ feature.text }}: <strong>{{ feature.value | percentage : 0 : true }}</strong></li>
    </ng-container>
  </ul>
</div>